import { ProductSlug } from "@/api/product-api";

export enum AddToCartResult {
  Success = "success",
  OverLimit = "over_limit",
  MergedToBundle = "merged_to_bundle",
}

export type CartItemOption = {
  type: string;
  value: string;
};

export type CartItem = {
  sku: string;
  slug: ProductSlug;
  quantity: number;
  options: CartItemOption[];
};

export type CartItemWithOptionalName = CartItem & {
  name?: string;
};
